import { Fragment, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __MUNICIPALITY_API_URL__ } from 'shell/constants/environment';
import FormMunicipality, { MunicipalityForm } from 'system/geographic/components/municipality/form';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonMunicipalityCrumbs, validationSchemaItalian } from '../constants';
import { HttpResponse } from 'shell/models/http-response';
import { Municipality } from 'shell/models/municipality';
import { toast } from 'react-toastify';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import {
  transformResponseMunicipalityEditItalian,
  transformRequestMunicipalityItalian,
} from 'system/geographic/utils/transformer-municipality-edit';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';

const MunicipalityEditPage = (): React.ReactElement => {
  const params = useParams();

  const updateMunicipality = useHttpClient(`${__MUNICIPALITY_API_URL__}/geo/comune/denominazione`, {
    options: {
      errorCatching: true,
      method: 'PUT',
      loading: true,
    },
  });

  const [municipalityData] = useHttpFetch<HttpResponse<Municipality>, MunicipalityForm>(
    `${__MUNICIPALITY_API_URL__}/geo/comune/${params.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
      },
      transformer: transformResponseMunicipalityEditItalian,
    }
  );

  const municipality = municipalityData.data as MunicipalityForm;

  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues: MunicipalityForm | undefined) => {
      const data = transformRequestMunicipalityItalian(formValues);
      (
        updateMunicipality({
          url: `/${formValues?.code}`,
          data,
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/geografiche/comune');
      });
    },
    [updateMunicipality, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs
        items={[...CommonMunicipalityCrumbs, { name: 'Cambio Denominazione Comune Italiano' }]}
      />
      {municipalityData.isLoading || municipalityData.hasErrors || !municipality ? undefined : (
        <FormMunicipality
          title="Cambio Denominazione Comune Italiano"
          onOk={onSubmit}
          isChangeName
          validationSchema={validationSchemaItalian}
          initialValues={municipality}
          onCancel={() => {
            navigate('/sistema/geografiche/comune');
          }}
        />
      )}
    </Fragment>
  );
};

MunicipalityEditPage.displayName = 'Municipality edit page component';

export default MunicipalityEditPage;
